import { useTranslation } from "react-i18next";

const useIntervalDescription = () => {
  const { t } = useTranslation();

  return {
    getDescription: (interval: number): string => {
      switch (interval) {
        case 1:
          return t("Everyday");
        case 7:
          return t("Every week");
        case 30:
          return t("Every month");
        case 180:
          return t("Every half year");
        default:
          return `${t("Every")} ${interval} ${t("days")}`;
      }
    },
  };
};

export default useIntervalDescription;
